<template>
	<div>药品管理</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>